module.exports = __webpack_public_path__ + "img/item3-pc.25be6eb7.png";